import React, { Suspense, lazy } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import './App.css';

const Statistics = lazy(() => import('./components/Statistics'));
const TrustStats = lazy(() => import('./components/TrustStats'));
const CoreFeatures = lazy(() => import('./components/CoreFeatures'));
const AIPower = lazy(() => import('./components/AIPower'));
const Comparison = lazy(() => import('./components/Comparison'));
const Integrations = lazy(() => import('./components/Integrations'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const BusinessTypes = lazy(() => import('./components/BusinessTypes'));
const Team = lazy(() => import('./components/Team'));
const CTA = lazy(() => import('./components/CTA'));
const Footer = lazy(() => import('./components/Footer'));

/** Pastki bloklar yuklanishi — Speed Index: birinchi viewport tezroq to‘ldiriladi */
function BelowFoldFallback() {
  return (
    <div
      className="app-below-fold-placeholder"
      style={{ minHeight: '40vh', background: 'transparent' }}
      aria-hidden="true"
    />
  );
}

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Suspense fallback={<BelowFoldFallback />}>
        <Statistics />
        <TrustStats />
        <CoreFeatures />
        <AIPower />
        <Comparison />
        <Integrations />
        <Testimonials />
        <BusinessTypes />
        <Team />
        <CTA />
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;
